<template>
	<Cascader 
		:disabled="disabled"
		ref="cascader"
		filterable 
		transfer
		:data="list" 
		:render-format="format"
		@on-change="change" 
		:value="handleCode(value)">
	</Cascader>
</template>
<script>
export default {
	props:{
		value:String,
		productCode:{
			type:String,
			default:''
		},
		disabled:{
			type: Boolean,
			default: false
		},
		list:{
			type: Array,
			default: []
		},
	},
	data(){
		return {
			jobList:this.list
		}
	},
	mounted(){
		this.handleCode('3101010011')
	},
	methods:{
		// 处理成数组
		handleCode (code){
			if(code){
				return this.getParentsById(this.list,code)
			}
		},
		getParentsById(list, id) {
			for (let i in list) {
				if (list[i].value == id) {
					return [list[i].value]
				}
				if (list[i].children) {
					let node = this.getParentsById(list[i].children, id)
					if (node !== undefined) {
						// 追加父节点
						node.unshift(list[i].value)
						return node
					}
				}
			}
		},
		// 选择
		change (code, val) {
			let data = val[val.length-1]
			if (data) {
				if (data.isRefuse==1) {
					this.alert('当前所选职业不符合投保条件');
					this.$refs.cascader.clearSelect()
				} else {
					this.$emit('change',val.length>0?val[val.length-1]:{
						value:'',
						category:''
					});
				}
			} else {
				this.$emit('change',{
					value:'',
					category:''
				});
			}
		},
		// 展示格式化
		format (labels, selectedData) {
			const index = labels.length - 1;
			return labels[index];
		},
		// 动态加载选项
		loadData (item, callback) {
			item.loading=true;
			let newItem=this.jobList.find(newItem=>{
				return newItem.value==item.value;
			})
			item.children=newItem.children;
			item.loading=false;
			callback();
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/common/SelectJob.vue